import React from 'react';
import './ConfirmationDialog.scss';
import { confirmButton, cancelButton } from '../Buttons';
import LoadingSubmitButton from '../LoadingSubmitButton';

const ConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  description,
  children,
  confirmText = 'אישור',
  cancelText = 'ביטול',
  onCancel,
  isConfirmLoading = false,
  confirmLoadingText = '', 
}) => {
  if (!open) return null;

  return (
    <div className="confirmation-dialog-overlay">
      <div className="confirmation-dialog">
        <h2 className="confirmation-dialog-title">{title}</h2>

        <div className="confirmation-dialog-message">
          {children || description}
        </div>

        <div className="confirmation-dialog-actions">
          <LoadingSubmitButton
            onClick={onConfirm}
            isLoading={isConfirmLoading}
            text={confirmText}
            loadingText={confirmLoadingText || 'שומר…'}
            
            style={confirmButton}
          />

          <button
            onClick={onCancel || onClose}
            style={cancelButton}
            disabled={isConfirmLoading} 
          >
            {cancelText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationDialog;
